import * as React from 'react';

import css from './PasswordForgot.module.scss';

export const PasswordForgot = (props: { message: string }) => {
  return (
    <div className={css.PasswordForgot}>
      <a href="/password/reset_requests/new">{props.message}</a>
    </div>
  );
};
